import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const Hierarchy1Icon = (props: BaseSVGProps) => {
  return (
    <BaseSVG viewBox="0 0 14 12" fill="none" {...props}>
      <path
        d="M13 0.5H10C9.72386 0.5 9.5 0.72386 9.5 1V4C9.5 4.27614 9.72386 4.5 10 4.5H13C13.2761 4.5 13.5 4.27614 13.5 4V1C13.5 0.72386 13.2761 0.5 13 0.5Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 7.5H10C9.72386 7.5 9.5 7.72386 9.5 8V11C9.5 11.2761 9.72386 11.5 10 11.5H13C13.2761 11.5 13.5 11.2761 13.5 11V8C13.5 7.72386 13.2761 7.5 13 7.5Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 4H1C0.723858 4 0.5 4.22386 0.5 4.5V7.5C0.5 7.77614 0.723858 8 1 8H4C4.27614 8 4.5 7.77614 4.5 7.5V4.5C4.5 4.22386 4.27614 4 4 4Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.5 5.22228L9.5 2.77783" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.5 6.77783L9.5 9.22226" strokeLinecap="round" strokeLinejoin="round" />
    </BaseSVG>
  )
}
